<template>
  <div class="search_page page">
    <TastingHeader v-bind:tastingInfo="currentTastingDeets" />
    <div class="container content_area_sm">
      <div class="spacer"></div>
      <div class="search-wrapper">
        <div class="row" v-show="firstLevelFilter != 'NONE'">
          <div class="col-12 text-center search-steps">
            <small>TYPE</small>
            <h2 class="text-center">{{ firstLevelFilter }}</h2>
            <div class="text-center" v-show="secondLevelFilter != 'NONE'">
              <img src="@/assets/angle-down.svg" style="height: 40px" /><br />
              <small>{{ filterLabel(secondLevelFilterType) }}</small>
              <h2 class="text-center">
                {{ secondLevelFilter }}
              </h2>
            </div>
            <div class="text-center" v-show="thirdLevelFilter != 'NONE'">
              <img src="@/assets/angle-down.svg" style="height: 40px" /><br />
              <small>{{ filterLabel(thirdLevelFilterType) }}</small>
              <h2 class="text-center">
                {{ thirdLevelFilter }}
              </h2>
            </div>
          </div>
        </div>

        <div class="form-row" v-show="firstLevelFilter == 'NONE'">
          <div class="col-12"><h1 class="text-center">Search & Filter</h1></div>
          <div class="col-12"><h2>Select Type</h2></div>
          <div class="col-12 spirit_type_search">
            <!--<select name="types" id="types" class="form-control" v-model="firstLevelFilter">
              <option>Please Select</option>
              <option v-for="(item, index) in itemTypesR" :key="index">{{ item }}</option>
            </select>-->
            <div v-for="(item, index) in itemTypesR" :key="index" class="text-center">
              <!-- <input type="radio" :id="item" :value="item" v-model="firstLevelFilter" />
              <label style="display: inline; text-transform: capitalize" :for="item">{{ item }}</label> -->

              <button class="btn btn-primary" style="width: 100%; margin-top: 20px" @click="firstLevelFilter = item">
                {{ item }}
                <img :src="'/img/' + item + '.svg'" style="height: 30px; vertical-align: middle; margin-top: -5px; display: none" />
              </button>
            </div>
          </div>
        </div>
        <!-- allow user to view results. -->
        <div class="padd_section">
          <div class="form-row" v-show="firstLevelFilter != 'NONE'">
            <div class="col-12">
              <router-link to="/browse"
                ><button class="btn btn-primary" style="width: 100%; margin-top: 20px" :disabled="resultCount < 1">
                  View {{ resultCount }} {{ pluralResults }}
                </button></router-link
              >
            </div>
            <div class="col-12">
              <button class="btn btn-secondary btn-fw" style="width: 100%; margin-top: 20px" @click="clearFilter">Clear Filter</button>
            </div>
          </div>
        </div>

        <!-- START SECOND LEVEL FILTERS -->
        <div class="padd_section" v-show="resultCount >= 4">
          <div class="form-row" v-show="firstLevelFilter == 'WINE'">
            <div class="col-12" v-show="secondLevelFilterType == 'NONE'">
              <h3 style="text-align: center">Add a Filter?</h3>

              <select name="wineFilters" id="wineFilters" class="form-control" v-model="secondLevelFilterType">
                <option value="NONE" selected>Choose a Wine Filter</option>
                <option v-for="(item, index) in wineFilters" :key="index" :value="item.field">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row" v-show="firstLevelFilter == 'SPIRITS'">
            <div class="col-12" v-show="secondLevelFilterType == 'NONE'">
              <select name="spiritFilters" id="spiritFilters" class="form-control" v-model="secondLevelFilterType">
                <option value="NONE" selected>Choose a Spirit Filter</option>
                <option v-for="(item, index) in spiritFilters" :key="index" :value="item.field">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row" v-show="firstLevelFilter == 'CIDER'">
            <div class="col-12" v-show="secondLevelFilterType == 'NONE'">
              <select name="ciderFilters" id="ciderFilters" class="form-control" v-model="secondLevelFilterType">
                <option value="NONE" selected>Choose a Cider Filter</option>
                <option v-for="(item, index) in ciderFilters" :key="index" :value="item.field">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row" v-show="firstLevelFilter == 'SAKE'">
            <div class="col-12" v-show="secondLevelFilterType == 'NONE'">
              <select name="sakeFilters" id="sakeFilters" class="form-control" v-model="secondLevelFilterType">
                <option value="NONE" selected>Choose a Sake Filter</option>
                <option v-for="(item, index) in sakeFilters" :key="index" :value="item.field">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12" v-show="secondLevelFilterOptions.length && secondLevelFilter == 'NONE'">
              Select {{ filterLabel(secondLevelFilterType) }}<br />
              <select name="secondFilters" id="secondFilters" class="form-control" v-model="secondLevelFilter">
                <option value="NONE" selected>Please Select</option>
                <option v-for="(item, index) in secondLevelFilterOptions" :key="index">{{ item }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- START THIRD LEVEL FILTERS -->
        <div class="padd_section" v-show="resultCount >= 4">
          <div class="form-row">
            <div class="col-12" v-show="firstLevelFilter == 'WINE' && thirdLevelFilterType == 'NONE' && secondLevelFilter != 'NONE'">
              <h5 style="text-align: center">Add Another Filter?</h5>

              <select name="wineFilters" id="wineFilters" class="form-control" v-model="thirdLevelFilterType">
                <option value="NONE" selected>Choose a Wine Filter</option>
                <option v-for="(item, index) in wineFilters" :key="index" :value="item.field">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12" v-show="firstLevelFilter == 'SPIRITS' && thirdLevelFilterType == 'NONE' && secondLevelFilter != 'NONE'">
              <h5 style="text-align: center">Add Another Filter?</h5>

              <select name="spiritFilters" id="spiritFilters" class="form-control" v-model="thirdLevelFilterType">
                <option value="NONE" selected>Choose a Spirit Filter</option>
                <option v-for="(item, index) in spiritFilters" :key="index" :value="item.field">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12" v-show="firstLevelFilter == 'CIDER' && thirdLevelFilterType == 'NONE' && secondLevelFilter != 'NONE'">
              <h5 style="text-align: center">Add Another Filter?</h5>

              <select name="ciderFilters" id="ciderFilters" class="form-control" v-model="thirdLevelFilterType">
                <option value="NONE" selected>Choose a Cider Filter</option>
                <option v-for="(item, index) in ciderFilters" :key="index" :value="item.field">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12" v-show="firstLevelFilter == 'SAKE' && thirdLevelFilterType == 'NONE' && secondLevelFilter != 'NONE'">
              <h5 style="text-align: center">Add Another Filter?</h5>

              <select name="sakeFilters" id="sakeFilters" class="form-control" v-model="thirdLevelFilterType">
                <option value="NONE" selected>Choose a Sake Filter</option>
                <option v-for="(item, index) in sakeFilters" :key="index" :value="item.field">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12" v-show="thirdLevelFilterOptions.length && thirdLevelFilter == 'NONE'">
              Select {{ filterLabel(thirdLevelFilterType) }}<br />
              <select name="thirdFilters" id="thirdFilters" class="form-control" v-model="thirdLevelFilter">
                <option value="NONE" selected>Please Select</option>
                <option v-for="(item, index) in thirdLevelFilterOptions" :key="index">{{ item }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="padd_section">
          <div class="form-row">
            <div class="col-12 text-center" v-show="firstLevelFilter != 'NONE'">
              <div :class="{ 'slider-disabled': activePriceFilter === 'ppo' }">
                Select Max Bottle Price: <strong>${{ slider }}</strong>
                <input type="range" :min="minCasePrice" :max="maxCasePrice" step="1" v-model="slider" :disabled="activePriceFilter === 'ppo'" @input="onBottleSliderInput" />
              </div>
              <div v-if="showPpo && firstLevelFilter === 'SPIRITS' && maxPpo > 0" :class="{ 'slider-disabled': activePriceFilter === 'bottle' }" style="margin-top: 10px;">
                Select Max Price Per Oz: <strong>${{ ppoSlider }}/oz</strong>
                <input type="range" :min="minPpo" :max="maxPpo" step="0.01" v-model="ppoSlider" :disabled="activePriceFilter === 'bottle'" @input="onPpoSliderInput" />
              </div>
            </div>
          </div>
        </div>

        <!--<pre>   {{ resultData }}</pre>-->
      </div>
    </div>
  </div>
</template>

<script>
//import SkuPreview from '@/components/SkuPreview.vue';
import { mapGetters, mapActions } from 'vuex';
import TastingHeader from '@/components/TastingHeader.vue';

export default {
  name: 'SearchPage',
  components: { TastingHeader },
  computed: {
    ...mapGetters(['alldata', 'currentTasting', 'currentTastingDeets', 'showPpo']),
    pluralResults() {
      if (this.resultCount == 1) {
        return `Result`;
      } else {
        return `Results`;
      }
    },
    itemTypesR() {
      const itemTypes = [];
      for (const sku in this.alldata.skus) {
        if (
          typeof this.alldata.skus[sku].type != 'undefined' &&
          this.alldata.skus[sku].type != '' &&
          this.alldata.skus[sku].type != 'GLASS' &&
          this.alldata.skus[sku].type != 'SPECWINE' &&
          this.alldata.skus[sku].type != 'SYRUP' &&
          this.alldata.skus[sku].type != 'NSS'
        ) {
          if (itemTypes.indexOf(this.alldata.skus[sku].type) === -1) {
            itemTypes.push(this.alldata.skus[sku].type);
          }
        }
      }
      if (itemTypes.length == 1) {
        this.firstLevelFilter = itemTypes[0];
      }
      return itemTypes;
    },
  },
  data() {
    return {
      filteredData: [],
      resultData: [],
      activeType: 'All',
      slider: '12',
      maxCasePrice: 1000,
      minCasePrice: 1,
      ppoSlider: null,
      maxPpo: 0,
      minPpo: 0,
      activePriceFilter: 'none',
      activeCountry: 'All',
      itemCountriesR: this.itemCountries,
      activeRegion: 'All',
      itemRegionsR: this.itemRegions,
      search: '',
      value: 0,
      resultCount: 0,
      currentFilters: '',
      firstLevelFilter: 'NONE',
      secondLevelFilterType: 'NONE',
      secondLevelFilter: 'NONE',
      secondLevelFilterOptions: [],
      thirdLevelFilterType: 'NONE',
      thirdLevelFilter: 'NONE',
      thirdLevelFilterOptions: [],
      wineFilters: [
        { name: 'Producer', field: 'producer' },
        { name: 'Color', field: 'c' },
        { name: 'Country', field: 'co' },
        { name: 'Region', field: 'r' },
        { name: 'Grape Variety', field: 'va' },
        { name: 'Vintage', field: 'v' },
        { name: 'Farming Practice', field: 'fp' },
        { name: 'Appellation', field: 'ap' },
      ],
      spiritFilters: [
        { name: 'Producer', field: 'producer' },
        { name: 'Spirit Type', field: 'st' },
        { name: 'Spirit Sub Type', field: 'sst' },
        { name: 'Country', field: 'co' },
        { name: 'Region', field: 'r' },

        { name: 'Vintage', field: 'v' },
        { name: 'Farming Practice', field: 'fp' },
      ],
      sakeFilters: [
        { name: 'Producer', field: 'producer' },
        // TEMP REMOVED { name: 'Sake Type', field: 'sst' },
        { name: 'Region', field: 'r' },
        { name: 'Rice Variety', field: 'va' },
        // TEMP REMOVED { name: 'RS Level', field: 'rs' },
        { name: 'Sake Type', field: 'sk' },
       // { name: 'Rice Category', field: 'rc' },
      ],
      ciderFilters: [
        { name: 'Producer', field: 'producer' },
        { name: 'Color', field: 'c' },
        { name: 'Country', field: 'co' },
        { name: 'Region', field: 'r' },

        { name: 'Vintage', field: 'v' },
        { name: 'Farming Practice', field: 'fp' },

        { name: 'RS Level', field: 'rs' },
      ],
      fortifiedFilters: [
        { name: 'Producer', field: 'producer' },

        { name: 'Country', field: 'co' },

        { name: 'Region', field: 'r' },
         { name: 'Appellation', field: 'ap' },
        { name: 'Grape Variety', field: 'va' },
        { name: 'Color', field: 'c' },
        { name: 'Vintage', field: 'v' },
        { name: 'Farming Practice', field: 'fp' },

      ],
    };
  },
  watch: {
    firstLevelFilter() {
      this.activePriceFilter = 'none';
      this.ppoSlider = null;
      this.getfilteredData();
    },
    slider: 'getfilteredData', // 1
    ppoSlider: 'getfilteredData',
    secondLevelFilter: 'getfilteredData',
    thirdLevelFilter: 'getfilteredData',
    secondLevelFilterType: 'getFilterOptions',
    thirdLevelFilterType: 'getFilterOptionsThird',
  },
  methods: {
    ...mapActions(['fetchAlldata', 'setResultTables', 'setResultFilters']),
    filterLabel(field) {
      if (field === 'va' && this.firstLevelFilter === 'SAKE') return 'Rice Variety';
      const labels = { c: 'Color', co: 'Country', r: 'Region', va: 'Grape Variety', v: 'Vintage', fp: 'Farming Practice', ap: 'Appellation', st: 'Spirit Type', sst: 'Spirit Sub Type', sk: 'Sake Type', rs: 'RS Level', rc: 'Rice Category', k: 'Kosher', producer: 'Producer' };
      return labels[field] || field;
    },
    onBottleSliderInput() {
      if (this.activePriceFilter === 'none') {
        this.activePriceFilter = 'bottle';
      }
    },
    onPpoSliderInput() {
      if (this.activePriceFilter === 'none') {
        this.activePriceFilter = 'ppo';
      }
    },
    getSkuPpo(sku, allpricing) {
      if (!allpricing || !allpricing.data || !allpricing.data[sku]) return null;
      const entry = allpricing.data[sku][0];
      if (!entry || !entry.ppo) return null;
      const firstKey = Object.keys(entry.ppo)[0];
      return firstKey ? entry.ppo[firstKey] : null;
    },
    viewResults() {
      //this.$store.commit('hideIntro');
      this.$router.push({ name: 'Browse' });
    },
    clearFilter() {
      //this.$store.commit('hideIntro');
      (this.firstLevelFilter = 'NONE'),
        (this.secondLevelFilterType = 'NONE'),
        (this.secondLevelFilter = 'NONE'),
        (this.secondLevelFilterOptions = []),
        (this.thirdLevelFilterType = 'NONE'),
        (this.thirdLevelFilter = 'NONE'),
        (this.thirdLevelFilterOptions = []),
        (this.resultCount = 0),
        (this.slider = 12),
        (this.ppoSlider = null),
        (this.activePriceFilter = 'none'),
        (this.currentFilters = false),
        this.getfilteredData();
    },
    getFilterOptions() {
      const type = this.secondLevelFilterType;
      const items = [];

      console.log('looking for second filter opts');
      for (const table in this.resultData) {
        //console.log(this.filteredData[table]);
        for (const sku in this.resultData[table].skus) {
          if (typeof this.resultData[table].skus[sku] != 'undefined') {
            //console.log(this.resultData[table].skus[sku][type]);
            if (typeof this.resultData[table].skus[sku][type] != 'undefined' && this.resultData[table].skus[sku][type] != '') {
              if (items.indexOf(this.resultData[table].skus[sku][type]) === -1) {
                items.push(this.resultData[table].skus[sku][type]);
              }
            }
          }
        }
      }
      items.sort();
      
      if (type=='v') { items.reverse();}
      this.secondLevelFilterOptions = items;
    },
    getFilterOptionsThird() {
      const type = this.thirdLevelFilterType;
      const items = [];
      console.log('looking for third filter opts');
      for (const table in this.resultData) {
        //console.log(this.filteredData[table]);
        for (const sku in this.resultData[table].skus) {
          if (typeof this.resultData[table].skus[sku] != 'undefined') {
            //console.log(this.resultData[table].skus[sku][type]);
            if (typeof this.resultData[table].skus[sku][type] != 'undefined' && this.resultData[table].skus[sku][type] != '') {
              if (items.indexOf(this.resultData[table].skus[sku][type]) === -1) {
                items.push(this.resultData[table].skus[sku][type]);
              }
            }
          }
        }
      }
      items.sort();
      if (type=='v') { items.reverse();}
      this.thirdLevelFilterOptions = items;
    },
    getfilteredData(whatChanged) {
      const filteredDataByfilters = new Object();
      const filteredDataBySearch = new Object();
      // first check if filters where selected
      this.resultData = JSON.parse(JSON.stringify(this.$store.getters.alldata.tables));
      this.resultFilters = false;
      this.resultCount = 0;
      //console.log('before first ' + this.resultCount);

      if (this.firstLevelFilter != 'NONE') {
        this.resultCount = 0;
        for (const table in this.resultData) {
          //console.log(this.filteredData[table]);
          for (const sku in this.resultData[table].skus) {
            //console.log(this.filteredData[table].skus[sku]);
            if (this.resultData[table].skus[sku].ty != this.firstLevelFilter) {
              delete this.resultData[table].skus[sku];
            } else {
              this.resultCount++;
            }
          }
        }
        this.currentFilters = this.firstLevelFilter;
      }
      //console.log('Before 2nd ' + this.resultCount);

      if (this.secondLevelFilter != 'NONE') {
        this.resultCount = 0;
        const type = this.secondLevelFilterType;
        for (const table in this.resultData) {
          //console.log(this.filteredData[table]);
          for (const sku in this.resultData[table].skus) {
            //console.log(this.filteredData[table].skus[sku]);
            if (this.resultData[table].skus[sku][type] != this.secondLevelFilter) {
              delete this.resultData[table].skus[sku];
            } else {
              this.resultCount++;
            }
          }
        }
        this.currentFilters = this.firstLevelFilter + ' &nbsp;&gt;&nbsp; ' + this.secondLevelFilter;
      }
      //console.log('BEFORE 3rd ' + this.resultCount);

      if (this.thirdLevelFilter != 'NONE') {
        this.resultCount = 0;
        const type = this.thirdLevelFilterType;
        for (const table in this.resultData) {
          //console.log(this.filteredData[table]);
          for (const sku in this.resultData[table].skus) {
            //console.log(this.filteredData[table].skus[sku]);
            if (this.resultData[table].skus[sku][type] != this.thirdLevelFilter) {
              delete this.resultData[table].skus[sku];
            } else {
              this.resultCount++;
            }
          }
        }
        this.currentFilters =
          this.firstLevelFilter + ' &nbsp;&gt;&nbsp; ' + this.secondLevelFilter + ' &nbsp;&gt;&nbsp; ' + this.thirdLevelFilter;
      }
      //console.log('BEFORE MAX & MIN ' + this.resultCount);

      //get our max and min prices.
      const prices = [];
      for (const table in this.resultData) {
        for (const sku in this.resultData[table].skus) {
          if (this.resultData[table].skus[sku].mc != null) {
            if (prices.indexOf(parseInt(this.resultData[table].skus[sku].mc)) === -1) {
              prices.push(parseInt(this.resultData[table].skus[sku].mc));
            }
          }
        }
      }
      this.maxCasePrice = Math.max(...prices);
      this.minCasePrice = Math.min(...prices);
      this.maxCasePrice = this.maxCasePrice + 1;
      this.minCasePrice = this.minCasePrice - 1;
      if (this.slider == 12 || this.slider > this.maxCasePrice) {
        this.slider = this.maxCasePrice;
      }

      // Compute PPO min/max for spirits
      if (this.showPpo && this.firstLevelFilter === 'SPIRITS') {
        const allpricing = JSON.parse(window.localStorage.getItem('pricing'));
        const ppoValues = [];
        if (allpricing && allpricing.data) {
          for (const table in this.resultData) {
            for (const sku in this.resultData[table].skus) {
              const skuPricing = allpricing.data[sku];
              if (skuPricing && skuPricing[0] && skuPricing[0].ppo) {
                const firstKey = Object.keys(skuPricing[0].ppo)[0];
                if (firstKey) {
                  ppoValues.push(parseFloat(skuPricing[0].ppo[firstKey]));
                }
              }
            }
          }
        }
        if (ppoValues.length > 0) {
          this.maxPpo = Math.max(...ppoValues);
          this.minPpo = Math.min(...ppoValues);
          if (this.ppoSlider === null || this.ppoSlider > this.maxPpo) {
            this.ppoSlider = this.maxPpo;
          }
        } else {
          this.maxPpo = 0;
          this.minPpo = 0;
          this.ppoSlider = null;
        }
      } else {
        this.maxPpo = 0;
        this.minPpo = 0;
        this.ppoSlider = null;
      }

      // Filter by price based on which slider is active
      if (this.activePriceFilter === 'ppo' && this.ppoSlider != null && this.maxPpo > 0) {
        // PPO filter active — filter by price per oz
        this.resultCount = 0;
        const allpricing = JSON.parse(window.localStorage.getItem('pricing'));
        for (const table in this.resultData) {
          for (const sku in this.resultData[table].skus) {
            const skuPpo = this.getSkuPpo(sku, allpricing);
            if (skuPpo === null || parseFloat(skuPpo) > parseFloat(this.ppoSlider)) {
              delete this.resultData[table].skus[sku];
            } else {
              this.resultCount++;
            }
          }
        }
      } else if (this.activePriceFilter !== 'ppo' && this.slider != null) {
        // Bottle price filter (default when no slider interacted, or bottle explicitly active)
        this.resultCount = 0;
        for (const table in this.resultData) {
          for (const sku in this.resultData[table].skus) {
            if (parseInt(this.resultData[table].skus[sku].mc) > parseInt(this.slider)) {
              delete this.resultData[table].skus[sku];
            } else {
              this.resultCount++;
            }
          }
        }
      }

      this.$store.dispatch('setResultTables', this.resultData);
      this.$store.dispatch('setResultCount', this.resultCount);
      this.$store.dispatch('setResultFilters', this.currentFilters);
      if (false) {
        if (this.firstLevelFilter != 'NONE' && this.resultCount <= 2) {
          this.$router.push({ name: 'Browse' });
        }
      }
    },
  },
  created() {
    this.fetchAlldata();
  },
  mounted() {
    this.getfilteredData();
  },
};
</script>
